import { render, staticRenderFns } from "./RentalReturnIndex.vue?vue&type=template&id=0b4b20d3"
import script from "./RentalReturnIndex.vue?vue&type=script&lang=js"
export * from "./RentalReturnIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports